import React from "react";
import { Route } from "react-router-dom";
import lazyWithRetry from "helpers/lazyWithRetry";

const businessDaysPage = lazyWithRetry(() => import("./BusinessDaysPage"));

export default [
  <Route
    exact
    path="/settings/business-days"
    key="business-days"
    component={businessDaysPage}
  />,
];
